type UrlMapping = Record<string, string>;

const reportingUrlMapping = '/:clientKey/reporting(/.*)?';

const urlMappings: UrlMapping = {
  '/paidsearch/:clientKey/*': '/channels',
  '/meta/:clientKey/*': '/channels',
  '/retargeting/:clientKey/*': '/channels',
  '/messages/:clientKey/*': '/channels',
  '/:clientKey/email': '/channels',
  '/pricematch/:clientKey/*': '/channels',
  '/chat/insights/:clientKey': '/channels',
  '/:clientKey/meta/*': '/channels',
  '/:clientKey/paidsearch/*': '/channels',
  '/:clientKey/retargeting/*': '/channels',
  '/:clientKey/messages/*': '/channels',
  '/:clientKey/pricematch/*': '/channels',
  '/:clientKey/chat/insights': '/channels',
  '/:clientKey/parity': '/parity/$CLIENT_KEY',
  '/:clientKey/parity/*': '/parity/$CLIENT_KEY',
  // Settings routes - legacy paths map to new navbar link
  '/settings/:clientKey/*': '/$CLIENT_KEY/settings/guides',
  // Settings routes with :clientKey first (excluding guides/hotels which have direct links)
  '/:clientKey/settings/branding': '/$CLIENT_KEY/settings/guides',
  '/:clientKey/settings/price-check': '/$CLIENT_KEY/settings/guides',
  '/:clientKey/settings/price-config': '/$CLIENT_KEY/settings/guides',
  '/:clientKey/settings/hotel-details-finder': '/$CLIENT_KEY/settings/guides',
  '/:clientKey/settings/deactivation-center': '/$CLIENT_KEY/settings/guides',
  '/:clientKey/account/team': '/account/team/$CLIENT_KEY',
  '/:clientKey/account/team/*': '/account/team/$CLIENT_KEY',
  '/:clientKey/account/billing-management': '/account/billing-management/$CLIENT_KEY',
  '/:clientKey/account/billing-management/*': '/account/billing-management/$CLIENT_KEY',
  '/:clientKey/subscriptions': '/subscriptions/$CLIENT_KEY',
  '/:clientKey/subscriptions/*': '/subscriptions/$CLIENT_KEY',
};

export { urlMappings, reportingUrlMapping };
